exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-templates-home-index-jsx": () => import("./../../../src/templates/Home/index.jsx" /* webpackChunkName: "component---src-templates-home-index-jsx" */)
}

